(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.announcement = document.querySelector('.announcement-bar-section .utility-bar');

      this.setHeaderHeight();
      this.setAnnouncementHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.announcement && 'ResizeObserver' in window) {
        this.announcementObserver = new ResizeObserver(() => this.setAnnouncementHeight());
        this.announcementObserver.observe(this.announcement);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    setAnnouncementHeight() {
      const height = this.announcement?.getBoundingClientRect().height || 0;
      document.documentElement.style.setProperty('--northport-announcement-height', `${height}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      this.announcementObserver?.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  if (!customElements.get('exact-piece-status')) {
    customElements.define(
      'exact-piece-status',
      class ExactPieceStatus extends HTMLElement {
        connectedCallback() {
          if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.section) return;

            const source = data.html.getElementById(this.id);
            if (!source) return;

            this.dataset.available = source.dataset.available;
            this.classList.toggle('is-available', source.classList.contains('is-available'));
            this.classList.toggle('is-sold', source.classList.contains('is-sold'));
            this.innerHTML = source.innerHTML;
          });
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }
      }
    );
  }

  if (!customElements.get('northport-sold-recovery')) {
    customElements.define(
      'northport-sold-recovery',
      class NorthportSoldRecovery extends HTMLElement {
        connectedCallback() {
          if (typeof subscribe !== 'function' || typeof PUB_SUB_EVENTS === 'undefined') return;

          this.unsubscribe = subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
            if (data.sectionId !== this.dataset.section) return;

            const source = data.html.getElementById(this.id);
            if (!source) return;

            this.hidden = source.hasAttribute('hidden');
            this.innerHTML = source.innerHTML;
            this.closest('product-info')?.classList.toggle('ntp-product-shell--unavailable', !this.hidden);
          });
        }

        disconnectedCallback() {
          this.unsubscribe?.();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["northport-hero"] && !Shopify.designMode) return;
  try {
    
  class NorthportHero extends HTMLElement {
    connectedCallback() {
      this.prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.video = this.querySelector('.ntp-hero__video');
      this.frame = null;
      this.videoIdle = null;
      this.videoTimer = null;
      this.videoStartQueued = false;
      this.parallaxEnabled = false;
      this.revealVideo = () => this.video?.classList.add('is-ready');
      this.queueVideoStart = this.queueVideoStart.bind(this);
      this.updatePosition = this.updatePosition.bind(this);
      this.requestUpdate = this.requestUpdate.bind(this);
      this.syncParallax = this.syncParallax.bind(this);
      this.prefersReducedMotion.addEventListener('change', this.syncParallax);
      if (this.video?.readyState >= 2) {
        this.revealVideo();
      } else {
        this.video?.addEventListener('loadeddata', this.revealVideo, { once: true });
      }
      if (document.readyState === 'complete') {
        this.queueVideoStart();
      } else {
        window.addEventListener('load', this.queueVideoStart, { once: true });
      }
      this.syncParallax();
    }

    disconnectedCallback() {
      this.prefersReducedMotion?.removeEventListener('change', this.syncParallax);
      this.video?.removeEventListener('loadeddata', this.revealVideo);
      window.removeEventListener('load', this.queueVideoStart);
      if (this.videoIdle && 'cancelIdleCallback' in window) window.cancelIdleCallback(this.videoIdle);
      if (this.videoTimer) window.clearTimeout(this.videoTimer);
      this.video?.pause();
      this.disableParallax();
    }

    syncParallax() {
      if (this.dataset.parallax === 'true' && !this.prefersReducedMotion.matches) {
        this.enableParallax();
        this.queueVideoStart();
      } else {
        this.disableParallax();
        this.video?.pause();
      }
    }

    queueVideoStart() {
      if (
        !this.video ||
        this.videoStartQueued ||
        this.prefersReducedMotion.matches ||
        !this.isConnected ||
        document.readyState !== 'complete'
      ) return;

      this.videoStartQueued = true;
      const startVideo = () => {
        this.videoStartQueued = false;
        this.videoIdle = null;
        this.videoTimer = null;
        if (!this.isConnected || this.prefersReducedMotion.matches) return;
        this.video.play().catch(() => {});
      };

      if ('requestIdleCallback' in window) {
        this.videoIdle = window.requestIdleCallback(startVideo, { timeout: 1200 });
      } else {
        this.videoTimer = window.setTimeout(startVideo, 450);
      }
    }

    enableParallax() {
      if (this.parallaxEnabled) return;

      this.parallaxEnabled = true;
      window.addEventListener('scroll', this.requestUpdate, { passive: true });
      window.addEventListener('resize', this.requestUpdate, { passive: true });
      this.requestUpdate();
    }

    disableParallax() {
      if (this.parallaxEnabled) {
        window.removeEventListener('scroll', this.requestUpdate);
        window.removeEventListener('resize', this.requestUpdate);
        this.parallaxEnabled = false;
      }

      if (this.frame) window.cancelAnimationFrame(this.frame);
      this.frame = null;
      this.style.setProperty('--ntp-hero-shift', '0px');
    }

    requestUpdate() {
      if (this.frame) return;
      this.frame = window.requestAnimationFrame(this.updatePosition);
    }

    updatePosition() {
      this.frame = null;
      const bounds = this.getBoundingClientRect();

      if (bounds.bottom < 0 || bounds.top > window.innerHeight) return;

      const shift = Math.max(-4, Math.min(34, bounds.top * -0.08));
      this.style.setProperty('--ntp-hero-shift', `${shift}px`);
    }
  }

  if (!customElements.get('northport-hero')) {
    customElements.define('northport-hero', NorthportHero);
  }

  } catch(e) { console.error(e); }
})();
})();
